import {
	useLocation,
	NavLink,
} from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';

import { MenuItem, Props } from './Navbar.model';

import styles from './Navbar.module.scss';
import Icon from '../Icon/Icon';

const Navbar = ({ className = '', orientation = 'horizontal', onClickItem }: Props) => {
	const { isAuthorized, role } = useAuthorizationDataContext();
	const location = useLocation();

	const menuItems: MenuItem[] = [{
		defaultPathFor: ['Admin'],
		icon: 'user-friends',
		name: 'users',
		path: '/users',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	}, {
		defaultPathFor: ['Mentor', 'Mentee'],
		icon: 'user-friends',
		name: 'members',
		path: '/members-list',
		permissions: ['ViewUsers'],
	},
	{
		defaultPathFor: [],
		icon: 'books',
		name: 'resources',
		path: '/resources',
		permissions: ['ViewUsers'],
	},
	{
		defaultPathFor: [],
		icon: 'books',
		name: 'resources',
		path: '/resource-list',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	},
	{
		defaultPathFor: [],
		icon: 'calendar-alt',
		name: 'calendar',
		path: '/calendar',
		permissions: ['ViewUsers'],
	}, {
		defaultPathFor: [],
		icon: 'comment-alt-edit',
		name: 'feedback',
		path: '/feedbacks',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	}, {
		defaultPathFor: [],
		icon: 'life-ring',
		name: 'help',
		path: '/help-requests',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	}, {
		defaultPathFor: [],
		icon: 'video',
		name: 'videoFeedback',
		path: '/video-feedback',
		permissions: ['ViewAllUsers', 'ViewAllApplications'],
	},];

	const getActiveClassForDefaultRoute = (defaultFor: string[]): string => {
		if (location.pathname === '/') {
			if (defaultFor && defaultFor.includes(role)) {
				return styles.active;
			}
		}
		return '';
	}

	return (
		<ul className={`${styles.navbar} ${styles[orientation]} ${className}`}>
			{menuItems.map(
				(item, index) =>
					isAuthorized(item.permissions) && (
						<li key={`menuItem${index}`}>
							{orientation === 'vertical' && (

								<NavLink
									activeClassName={styles.active}
									to={item.path}
									onClick={() => onClickItem && onClickItem()}
									className={`${getActiveClassForDefaultRoute(
										item.defaultPathFor
									)} ${styles.navLink}`}
								>
									<div className={styles.iconContainer}>
										<Icon
											color="text"
											height="16px"
											name={item.icon}
											width="16px"
										/>
									</div>
										<FormattedMessage id={`navigation.${item.name}`} />
								
								</NavLink>
							)}
							{orientation === 'horizontal' && (
								<NavLink
									activeClassName={styles.active}
									to={item.path}
									onClick={() => onClickItem && onClickItem()}
									className={`${getActiveClassForDefaultRoute(
										item.defaultPathFor
									)} ${styles.navLink}`}
								>
									<div className={styles.iconContainer}>
										<Icon
											color="text"
											height="16px"
											name={item.icon}
											width="16px"
										/>
									</div>
										<FormattedMessage id={`navigation.${item.name}`} />
								
								</NavLink>
							)}
						</li>
					)
			)}
		</ul>
	);
}

export default Navbar;